import { render, staticRenderFns } from "./image-banner.vue?vue&type=template&id=279827cc&lang=html&"
import script from "./image-banner.vue?vue&type=script&lang=js&"
export * from "./image-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports